import { createApi } from "@reduxjs/toolkit/query/react";
import authBaseQuery from "../../../../utils/authBaseQuery";

const ExecutionApi = createApi({
  reducerPath: "ExecutionApi",
  baseQuery: authBaseQuery,
  tagTypes: ["CampaignData"],

  endpoints: (builder) => ({
    getVendorsByPageNames: builder.mutation({
      query: (payload) => ({
        url: "/v1/get_vendor_by_pagenames",
        method: "POST",
        body: payload,
      }),
    }),

    getCountExecutionCampStatus: builder.query({
      query: () => `count_exe_campaign_status`,
      transformResponse: (response) => response?.data,
    }),

    getCampaignDataStatusWise: builder.query({
      query: ({ status, page = 1, limit = 10, search = "" }) => {
        const queryParams = [];

        if (status) queryParams.push(`status=${status}`);
        if (page) queryParams.push(`page=${page}`);
        if (limit) queryParams.push(`limit=${limit}`);
        if (search?.trim())
          queryParams.push(`search=${encodeURIComponent(search)}`);

        const queryString =
          queryParams.length > 0 ? `?${queryParams.join("&")}` : "";
        return `campaigns_with_status${queryString}`;
      },
      providesTags: (result, error, arg) => [
        {
          type: "CampaignData",
          id: `${arg.status}-${arg.page}-${arg.limit}-${arg.search || ""}`,
        },
      ],
    }),

    updatExecutionCampaign: builder.mutation({
      query: (payload) => ({
        url: `edit_exe_campaign_status`,
        method: "PUT",
        body: payload,
      }),
      async onQueryStarted(payload, { dispatch, queryFulfilled }) {
        const { id, status, page = 1, limit = 10 } = payload;
        const patchResult = dispatch(
          ExecutionApi.util.updateQueryData(
            "getCampaignDataStatusWise",
            { status: payload.currentTabStatus, page, limit },
            (draft) => {
              const item = draft?.data?.find((d) => d._id === id);
              if (item && payload.status) {
                item.exe_campaign_status = payload.status;
              }
            }
          )
        );

        try {
          await queryFulfilled;
        } catch {
          patchResult.undo();
        }
      },
      invalidatesTags: ["CampaignData"],
    }),
  }),
});

export const {
  useGetVendorsByPageNamesMutation,
  useGetCountExecutionCampStatusQuery,
  useGetCampaignDataStatusWiseQuery,
  useUpdatExecutionCampaignMutation,
} = ExecutionApi;

export default ExecutionApi;
